import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=fdd5f67c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=fdd5f67c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd5f67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdd5f67c')) {
      api.createRecord('fdd5f67c', component.options)
    } else {
      api.reload('fdd5f67c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=fdd5f67c&scoped=true", function () {
      api.rerender('fdd5f67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/Sidebar.vue"
export default component.exports